import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import CampaignsSection from "./sectionpages/CampaignsSection";
import OperationsSection from "./sectionpages/OperationsSection";
import FeedbackSection from "./sectionpages/FeedbackSection";
import LogsSection from "./sectionpages/LogsSection";
import ReportsSection from "./sectionpages/ReportsSection";

const useCaseLabels = {
  "tv-ads": "📺 TV Ads",
  "online-ads": "💻 Online Ads",
  "print-billboards": "📰 Print/Billboards",

  "events": "🎪 Events",
  "product-demos": "🛍️ Product Demos",
  "direct-mail": "✉️ Direct Mail",

  "integrated": "🔗 Integrated Campaigns",
  "multi-channel": "🚀 Multi-channel Launch",
  "social-offline": "🌐 Social + Offline",
};

const sectionLabels = {
  campaigns: "Campaigns 🗂️",
  operations: "Operations 🛠️",
  feedback: "Customer Feedback 💬",
  logs: "Logs 📜",
  reports: "Reports & Analytics 📊",
};

const sectionComponents = {
  campaigns: CampaignsSection,
  operations: OperationsSection,
  feedback: FeedbackSection,
  logs: LogsSection,
  reports: ReportsSection,
};

const TReachSectionPage = () => {
  const { mode, usecase, section } = useParams();
  const navigate = useNavigate();

  // Select the correct component dynamically
  const SectionComponent = sectionComponents[section];

  return (
    <div className="min-h-screen bg-black text-white p-4">
      <button
        onClick={() => navigate(-1)}
        className="text-blue-400 underline text-sm mb-3"
      >
        ← Back
      </button>

      <div className="text-lg font-bold text-teal-300">
        {useCaseLabels[usecase]}
      </div>

      <div className="text-sm text-gray-400 mb-3">
        {sectionLabels[section]}
      </div>

      <div className="border-t border-gray-700 pt-3">
        {SectionComponent ? <SectionComponent usecase={useCaseLabels[usecase]} /> : null}
      </div>
    </div>
  );
};

export default TReachSectionPage;
